export default __webpack_public_path__ + "static/media/avatarA2.778f64fd.png";